module.exports = __webpack_public_path__ + "img/gwablogo.d0289dc0.png";